import type Application from "@/types/application";
import "./selected_application.scss";
import "@/stylesheets/dream_job_icon.scss";
import { StageCard } from "@components/applications/stage_card.tsx";
import Divider from "@sprout/divider.tsx";
import { useTranslation } from "react-i18next";
import { SectionTitle } from "@sprout/typography.tsx";

type Props = {
  application: Application;
};

const Stages = ({ application }: Props) => {
  const { t } = useTranslation("applications");

  const hasStage = application.visibleStages?.length || application.currentStage;

  return (
    hasStage && (
      <div className="stages border-1 border-gray-700 rounded-md">
        {application.visibleStages?.length ? (
          <>
            <SectionTitle>{t("stages")}</SectionTitle>
            {application.visibleStages?.map((visibleStage, index) => {
              const isCurrentStage = application.currentStage?.id === visibleStage.id;
              return (
                <>
                  {index !== 0 && <Divider />}
                  <StageCard
                    {...visibleStage}
                    isCurrentStage={isCurrentStage}
                    key={visibleStage.id}
                  />
                </>
              );
            })}
          </>
        ) : (
          application.currentStage && (
            <StageCard {...application.currentStage} isCurrentStage={true} />
          )
        )}
      </div>
    )
  );
};

export default Stages;
